// import { IconConnectionAi } from "common/components/Icons/IconConnectionAi/IconConnectionAi";
import { Common } from 'common/services/common.service';
import './actionItemsInfo.scss';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import { CveList } from '../Vulnerabilities/CveList/CveList';
import { TechnicalDetails } from 'common/components/TechnicalDetails/TechnicalDetails';
import { IconActiveProtection } from 'common/components/Icons/IconActiveProtection/IconActiveProtection';
import { LinkNewTab } from 'common/components/LinkNewTab/LinkNewTab';

export function ActionItemsInfo(props: any) {
  function onSetVisible() {
    props.setVisible(false);
  }

  const shouldShowBottomScope = (): boolean => {
    return props.data.required_action || !props.hideShowMore;
  };

  return (
    <div className="actionItemsInfo-scope">
      <div className="actionItemsInfo-header-scope">
        <div className="aii-header-main-scope">
          {props.data.title && <div className="aii-header-title">{props.data.title}</div>}
          <div className="aii-icon-remove" onClick={onSetVisible}>
            +
          </div>
        </div>
        <div className="aii-sub-header-scope">
          {props.data?.is_active_protection && (
            <div className="actionItemsInfo-sub-header-type-scope">
              <IconActiveProtection />
              <span className="aii-sub-header-value">Active Protection Applied</span>
            </div>
          )}
          {props.data.type && (
            <>
              {props.data?.is_active_protection && <div className="aii-icon-circle"></div>}
              <div className="actionItemsInfo-sub-header-type-scope">
                <span className="">Type</span>
                <span className="aii-sub-header-value">{props.data.type}</span>
              </div>
            </>
          )}

          {props.data.asset && (
            <>
              <div className="aii-icon-circle"></div>
              <div className="actionItemsInfo-sub-header-host-scope">
                <span className="">Asset Name</span>
                <span className="aii-sub-header-value">{props.data.asset}</span>
              </div>
            </>
          )}

          {props.data.first_opened_at && (
            <>
              <div className="aii-icon-circle"></div>
              <div className="actionItemsInfo-sub-header-date-scope">
                <span className="">{Common.getDateFormat(props.data.first_opened_at)}</span>
              </div>
            </>
          )}
        </div>
      </div>

      <div className="scrollbar-body">
        <div className="actionItemsInfo-body-scope">
          {props.data.summary && (
            <div className="aii-body-header-scope">
              <div className="aii-body-header">Summary</div>
              <div className="">{props.data.summary}</div>
            </div>
          )}

          {props.data.description && (
            <div className="aii-body-header-scope">
              <div className="aii-body-header">Description</div>
              <div className="pre-line">{props.data.description}</div>
            </div>
          )}

          {props.data.impact && (
            <div className="aii-body-header-scope">
              <div className="aii-body-header">Impact</div>
              <div className="pre-line">{props.data.impact}</div>
            </div>
          )}

          {props.data.cves && props.data.cves.length && (
            <div className="aii-body-header-scope">
              <div className="aii-body-header">CVE List</div>
              <div className="">
                <CveList data={props.data.cves} visible={true} />
              </div>
            </div>
          )}

          {props.data.references && (
            <div className="aii-body-header-scope">
              <div className="aii-body-header">References</div>
              <ul className="links-list">
                {Object.keys(props.data.references).map((reference: string) => {
                  return (
                    <li>
                      <LinkNewTab to={props.data.references[reference]} text={reference} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}

          <TechnicalDetails data={props.data.technical_details} />
        </div>
      </div>

      {shouldShowBottomScope() && (
        <div className="aii-bottom-scope">
          {props.data.required_action && (
            <div className="required-action-wrapper">
              <div className="">Required Action</div>
              <div className="aii-footer-title">{props.data.required_action}</div>
            </div>
          )}
          <div className="aii-bottom-events">
            {/* <div className="">Assignee</div> */}
            <div className="aii-bottom-events">
              {!props.hideShowMore && !props.data.is_asset_deleted && (
                <Button>
                  <Link
                    className="aii-elemnt-a-scope"
                    to={`/pages/singleAsset/internalAssets/${props.data.asset}/actionItems`}
                    title={'View single asset'}
                  >
                    Go to Asset
                  </Link>
                </Button>
              )}
              {/* <Button>
              <div className="aii-lable-scope">
                <IconCopy color={"#8796f0"} />
                <span className="aii-lable">Copy To Clipboard</span>
              </div>
            </Button> */}
              {/* <Button>
              <div className="integrate-with-scope">
                <div className="integrate-with-icon"></div>
                <div className="">Integrate with</div>
              </div>
            </Button> */}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
